import { render } from "./wf-dlt.vue?vue&type=template&id=0fe0f353&scoped=true"
import script from "./wf-dlt.vue?vue&type=script&lang=js"
export * from "./wf-dlt.vue?vue&type=script&lang=js"

import "./wf-dlt.vue?vue&type=style&index=0&id=0fe0f353&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe0f353"]])

export default __exports__